<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">

  <div class="columnbv1">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-right-0px">
      <!--<div class="row"></div>-->
        <div class="card height-100vh">
          <div class="card-header wh-header border-bottom padding-bottom-0px">
            <div class="row">
              <div class="col-md-3 margin-left-10px">
                <div class="row">
                  <a class="user-image-circle-65px">
                    <img class="img3" src="DR SITARAM.jpg">
                  </a>
                </div>
              </div>
              <div class="col-md-8">
                <div class="row a1">
                  <label class="margin-bottom-0px f2">Roopa</label>
                </div>
                <div class="row a1">
                  <label class="margin-bottom-0px f3">F/28</label>
                </div>
                <div class="row a1">
                  <label class="margin-bottom-0px f3">GGHO/2393</label>
                </div>
                <div class="row a1">
                  <label class="margin-bottom-0px f3">8801667136</label>
                </div>
              </div>
              <!--<div class="col-md-12">
                <label class="margin-bottom-0px">Patient Details</label>
              </div>-->
            </div>
          </div>
          <div class="card-body">
            <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" (click)="billdetails()">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-8">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">12-May-2020</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2 font-size-11px">OP-GGHO-2354</label>
                    </div>

                  </div>
                  <div class="col-md-4">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-size-16px font-weight-bold">939</label>
                    </div>

                  </div>
                </div>






              </div>
            </div>

            <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" (click)="billdetails()">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-8">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">12-May-2020</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2 font-size-11px">OP-GGHO-2354</label>
                    </div>

                  </div>
                  <div class="col-md-4">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-size-16px font-weight-bold">939</label>
                    </div>

                  </div>
                </div>






              </div>
            </div>
            <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" (click)="billdetails()">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-8">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">12-May-2020</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2 font-size-11px">OP-GGHO-2354</label>
                    </div>

                  </div>
                  <div class="col-md-4">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-size-16px font-weight-bold">939</label>
                    </div>

                  </div>
                </div>






              </div>
            </div>
            <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" (click)="billdetails()">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-8">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">12-May-2020</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2 font-size-11px">OP-GGHO-2354</label>
                    </div>

                  </div>
                  <div class="col-md-4">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-size-16px font-weight-bold">939</label>
                    </div>

                  </div>
                </div>






              </div>
            </div>
            <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" (click)="billdetails()">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-8">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">12-May-2020</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2 font-size-11px">OP-GGHO-2354</label>
                    </div>

                  </div>
                  <div class="col-md-4">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-size-16px font-weight-bold">939</label>
                    </div>

                  </div>
                </div>






              </div>
            </div>


          </div>

        </div>
      
    </div>
  </div>

  <div class="columnbv2" *ngIf="billdetails1">
    <div class="card height-100vh">

      <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt">

        <div class="row border-bottom">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="card">


              <div class="card-header wh-header border-bottom padding-bottom-0px">
                <div class="row border-bottom">
                  <div class="col-md-10">
                    <div class="row">
                      <label class="margin-bottom-0px">12-May-2020</label>
                    </div>
                    <div class="row">
                      <label class="margin-bottom-0px">OP-GGHO-5142</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="row">
                      <label class="margin-bottom-0px font-weight-bold">939</label>
                    </div>
                    <div class="row">
                      <label class="margin-bottom-0px">Paid</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body padding-top-5px padding-bottom-0px">
                <div class="row border-bottom-2px">
                  <div class="col-md-4">
                    <label class="margin-bottom-0px">Dr.Vijay</label>
                  </div>
                  <div class="col-md-4">
                    <label class="margin-bottom-0px">Dr.Asha</label>
                  </div>
                  <!--<div class="col-md-4">
                    <button type="submit" class="btn actions-btn-prime font-size-13px">Refund</button>
                  </div>-->
                </div>
                <div class="row margin-left-0px">
                  <label class="margin-bottom-0px">Services</label>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-component">
                      <div class="table-responsive overflow-x">


                        <table class="table table-striped"
                               cols="auto,2*,*,*,*,*,*,*">

                          <thead class="">
                            <tr>

                              <th class="min-width-24px">
                                #
                              </th>


                              <th class="">
                                Service Description
                              </th>
                              <th class="text-align-center">
                                QTY
                              </th>

                              <th class="text-align-center">
                                Unit Price
                              </th>

                              <th class="text-align-center">
                                Discount
                              </th>

                              <th class="text-align-center">
                                Item Rate
                              </th>
                              <!--<th class="">

                </th>-->
                              <th class="">

                              </th>






                            </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">Diagnostic Hysteroscope</td>

                              <td class="text-align-center td-padding-tb">1</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">100</td>
                              <td class="td-padding-tb text-align-center">2242</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">Diagnostic Hysteroscope</td>

                              <td class="text-align-center td-padding-tb">1</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">100</td>
                              <td class="td-padding-tb text-align-center">2242</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">Diagnostic Hysteroscope</td>

                              <td class="text-align-center td-padding-tb">1</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">100</td>
                              <td class="td-padding-tb text-align-center">2242</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">Diagnostic Hysteroscope</td>

                              <td class="text-align-center td-padding-tb">1</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">100</td>
                              <td class="td-padding-tb text-align-center">2242</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">Diagnostic Hysteroscope</td>

                              <td class="text-align-center td-padding-tb">1</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">100</td>
                              <td class="td-padding-tb text-align-center">2242</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                          </tbody>



                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row  margin-left-0px">
                  <label class="margin-bottom-0px">Receipts</label>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-component">
                      <div class="table-responsive overflow-x">


                        <table class="table table-striped"
                               cols="auto,2*,*,*,*,*,*,*">

                          <thead class="">
                            <tr>

                              <th class="min-width-24px">
                                #
                              </th>


                              <th class="">
                                Date
                              </th>
                              <th class="text-align-center">
                                Receipt No
                              </th>
                              <th class="text-align-center">
                                Payment Mode
                              </th>
                              <th class="text-align-center">
                                Amount
                              </th>

                              <th class="text-align-center">
                                Details
                              </th>

                              <th class="">

                              </th>






                            </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">16-06-2020</td>

                              <td class="text-align-center td-padding-tb">OP-GG-HO-2354</td>
                              <td class="text-align-center td-padding-tb ">Card</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">details</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">16-06-2020</td>

                              <td class="text-align-center td-padding-tb">OP-GG-HO-2354</td>
                              <td class="text-align-center td-padding-tb ">Card</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">details</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">16-06-2020</td>

                              <td class="text-align-center td-padding-tb">OP-GG-HO-2354</td>
                              <td class="text-align-center td-padding-tb ">Card</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">details</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">16-06-2020</td>

                              <td class="text-align-center td-padding-tb">OP-GG-HO-2354</td>
                              <td class="text-align-center td-padding-tb ">Card</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">details</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>
                            <tr>


                              <td class="td-padding-tb">

                                1
                              </td>
                              <td class=" td-padding-tb">16-06-2020</td>

                              <td class="text-align-center td-padding-tb">OP-GG-HO-2354</td>
                              <td class="text-align-center td-padding-tb ">Card</td>
                              <td class="text-align-center td-padding-tb ">2342</td>

                              <td class="td-padding-tb text-align-center">details</td>
                              <td class=" td-padding-tb ">
                                <a class="nav-link-hand" title="Remove"><i class="fa fa-times nav-link-hand"></i></a>
                                <a class="nav-link-hand education-navlink" title="Edit Plan">
                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </td>



                            </tr>

                          </tbody>



                        </table>
                      </div>
                    </div>
                  </div>
                </div>


              </div>






            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div class="columnbv3" *ngIf="billdetails2">



    <div class="card height-100vh">
      <div class="row">
        <div class="col-md-12">
          <h5 class="mb-0 height-24px">
            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Bill Header
            </button>
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h5 class="mb-0 height-24px">
            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Services
            </button>
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h5 class="mb-0 height-24px">
            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Receipts
            </button>
          </h5>
        </div>
      </div>
    </div>



  </div>


</div>
